import {ModuleWithProviders, NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {ContentPageTemplateComponent} from './components/templates/content-page-template/content-page-template.component';
import {BaseSiteComponent} from './components/base-site/base-site.component';
import {CmsConfig} from './config/cms.config';
import {DataAccessCmsPagesModule} from '@kion/data-access/data-access-cms-pages';
import {DynamicModule} from 'ng-dynamic-component';
import {UiModule} from '@kion/ui';
import {AccountComponent} from './shared/account/account.component';
import {LinkListComponent} from './shared/link-list/link-list.component';
import {LogoComponent} from './shared/logo/logo.component';
import {CopyrightComponent} from './shared/copyright/copyright.component';
import {PageTitleComponent} from './shared/page-title/page-title.component';
import {BreadcrumbComponent} from './shared/breadcrumb/breadcrumb.component';
import {OrderConfirmationComponent} from './shared/order-confirmation/order-confirmation.component';
import {ParagraphComponent} from './shared/paragraph/paragraph.component';
import {LanguageSwitchComponent} from './shared/language-switch/language-switch.component';
import {TitleComponent} from './shared/title/title.component';
import {DataAccessNavigationsModule} from '@kion/data-access/data-access-navigations';
import {DataAccessBreadcrumbModule} from '../../../../shared/data-access/data-access-breadcrumb/src';
import {NavigationComponent} from './shared/navigation/navigation.component';
import {MarkdownModule} from 'ngx-markdown';
import {LazyLoadImageModule} from 'ng-lazyload-image';
import {QuoteComponent} from './fs/quote/quote.component';
import {LargeLoginComponent} from './fs/large-login/large-login.component';
import {NwpAdminInviteComponent} from './fs/nwp-admin-invite/nwp-admin-invite.component';
import {NwpUserListComponent} from './fs/nwp-user-list/nwp-user-list.component';
import {NwpListComponent} from './fs/nwp-list/nwp-list.component';
import {DataAccessDevicesModule} from '@kion/data-access/data-access-devices';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {DataAccessFeatureEnablementsModule} from '@kion/data-access/data-access-feature-enablements';
import {DataAccessDeviceCartsModule} from '@kion/data-access/data-access-device-carts';
import {DataAccessRolesModule} from '@kion/data-access/data-access-roles';
import {TranslateModule} from '@ngx-translate/core';
import {DeviceListComponent} from './fs/device-list/device-list.component';
import {DeviceDetailComponent} from './fs/device-detail/device-detail.component';
import {FsUiModule} from '@kion/fs-ui';
import {DataAccessBaseSitesModule} from '@kion/data-access/data-access-base-sites';
import {DataAccessCmsComponentsModule} from '@kion/data-access/data-access-cms-components';
import {DataAccessPrivilegesModule} from '@kion/data-access/data-access-privileges';
import {DataAccessNetworkPartnersModule} from '@kion/data-access/data-access-network-partners';
import {DataAccessEmployeesModule} from '@kion/data-access/data-access-employees';
import {SignUpComponent} from './fs/sign-up/sign-up.component';
import {CmsComponentDirective} from './directives/cms-component.directive';
import {CmsSlotDirective} from './directives/cms-slot.directive';
import {HeroBannerComponent} from './lr/hero-banner/hero-banner.component';
// tslint:disable-next-line:nx-enforce-module-boundaries
import {LrUiModule} from '@kion/lr-ui';
import {ProductSliderComponent} from './lr/product-slider/product-slider.component';
import {DataAccessOrdersModule} from '@kion/data-access/data-access-orders';
import {NextStepComponent} from './shared/next-step/next-step.component';
import {ErrorComponent} from './shared/error/error.component';
import {PhoneComponent} from './lr/phone/phone.component';
import {CustomerSupportComponent} from './lr/customer-support/customer-support.component';
import {ProductDetailComponent} from './lr/product-detail/product-detail.component';
import {AuthenticationComponent} from './components/authentication/authentication.component';
// tslint:disable-next-line:nx-enforce-module-boundaries
import {BaseLinkResolverService} from '../../../../shared/ui/src/lib/shared/services/base-link-resolver.service';
import {LinkResolverService} from './services/link-resolver.service';
import {DataAccessBasketsModule} from '@kion/data-access/data-access-baskets';
import {DataAccessProductsModule} from '@kion/data-access/data-access-products';
import {DataAccessUsersModule} from '@kion/data-access/data-access-users';
import {HTTP_INTERCEPTORS} from '@angular/common/http';
import {KionInterceptor} from './interceptors/kion.interceptor';
import {IdpConfig} from './config/idp.config';
import {BasketComponent} from './lr/basket/basket.component';
import {CheckoutStepsComponent} from './lr/checkout-steps/checkout-steps.component';
import {LoginCheckoutComponent} from './lr/login-checkout/login-checkout.component';
import {CheckoutAllInOnePageTemplateComponent} from './components/templates/checkout-all-in-one-page-template/checkout-all-in-one-page-template.component';
import {CheckoutAddressComponent} from './lr/checkout-address/checkout-address.component';
import {CheckoutDeliveryComponent} from './lr/checkout-delivery/checkout-delivery.component';
import {CheckoutPaymentComponent} from './lr/checkout-payment/checkout-payment.component';
import {CheckoutSummaryComponent} from './lr/checkout-summary/checkout-summary.component';
import {DataAccessLmhSoftwareProductsModule} from "@kion/data-access/data-access-lmh-software-products";
import {DataAccessTitlesModule} from '@kion/data-access/data-access-titles';
import {DataAccessAddressModule} from '@kion/data-access/data-access-address';
import {SignUpCompleteComponent} from './lr/sign-up-complete/sign-up-complete.component';
import {TwoColumPageTemplateComponent} from './components/templates/two-colum-page-template/two-colum-page-template.component';
import {AccordionComponent} from './lr/accordion/accordion.component';
import {SimpleTitleComponent} from './lr/simple-title/simple-title.component';
import {ContactBoxComponent} from './lr/contact-box/contact-box.component';
import {ContactFormComponent} from './lr/contact-form/contact-form.component';
import {ContactConfirmationComponent} from './lr/contact-confirmation/contact-confirmation.component';
import {SearchResultListComponent} from './lr/search-result-list/search-result-list.component';
import {CategoryListComponent} from './lr/categoriy-list/category-list.component';
import {CategoryListItemComponent} from './lr/categoriy-list/category-list-item/category-list-item.component';
import {ContactComponent} from './lr/contact/contact.component';
import {TitledParagraphComponent} from './lr/titled-paragraph/titled-paragraph.component';
import {PaymentIconsComponent} from './lr/payment-icons/payment-icons.component';
import {SearchResultTitleComponent} from './lr/search-result-title/search-result-title.component';
import {SearchNoResultComponent} from './lr/search-no-result/search-no-result.component';
import {NotAvailableComponent} from './components/not-available/not-available.component';
import {TeaserComponent} from './lr/teaser/teaser.component';
import {ListItemComponent} from './fs/list-item/list-item.component';
import {SwiperModule} from 'swiper/angular';
import {SeoAccordionComponent} from './lr/seo/seo-accordion/seo-accordion.component';
import {SeoContentComponent} from './lr/seo/seo-content/seo-content.component';
import {PromotionBannerComponent} from './lr/promotion-banner/promotion-banner.component';
import {NetworkPartnerTermsAndConditionComponent} from './lr/network-partner-terms-and-condition/network-partner-terms-and-condition.component';
import {NetworkPartnerPrivacyPolicyComponent} from './lr/network-partner-privacy-policy/network-partner-privacy-policy.component';
import {DataAccessContractPartnersModule} from '../../../../shared/data-access/data-access-contract-partners/src';
import {OrderHistoryComponent} from "@kion/libs/lmh/cms/src/lib/fs/order-history/order-history.component";
import {OrderHistoryDetailComponent} from "@kion/libs/lmh/cms/src/lib/fs/order-history-detail/order-history-detail.component";
import {OrderHistoryQuoteComponent} from "@kion/libs/lmh/cms/src/lib/fs/order-history-quote/order-history-quote.component";
import {DataAccessOrderHistoryModule} from "@kion/libs/shared/data-access/data-access-orderhistory/src";

@NgModule({
  imports: [
    CommonModule,
    DynamicModule,
    MarkdownModule,
    LazyLoadImageModule,
    SwiperModule,
    TranslateModule,
    UiModule,
    FsUiModule,
    LrUiModule,
    DataAccessBaseSitesModule,
    DataAccessCmsComponentsModule,
    DataAccessCmsPagesModule,
    DataAccessNavigationsModule,
    DataAccessBreadcrumbModule,
    DataAccessDevicesModule,
    ReactiveFormsModule,
    DataAccessFeatureEnablementsModule,
    DataAccessLmhSoftwareProductsModule,
    DataAccessDeviceCartsModule,
    DataAccessRolesModule,
    DataAccessPrivilegesModule,
    DataAccessNetworkPartnersModule,
    DataAccessEmployeesModule,
    DataAccessOrderHistoryModule,
    DataAccessOrdersModule,
    DataAccessBasketsModule,
    DataAccessProductsModule,
    DataAccessUsersModule,
    DataAccessTitlesModule,
    DataAccessAddressModule,
    FormsModule,
    DataAccessContractPartnersModule
  ],
  declarations: [
    NetworkPartnerTermsAndConditionComponent,
    NetworkPartnerPrivacyPolicyComponent,
    ContentPageTemplateComponent,
    BaseSiteComponent,
    AccountComponent,
    LinkListComponent,
    LogoComponent,
    CopyrightComponent,
    PageTitleComponent,
    BreadcrumbComponent,
    OrderConfirmationComponent,
    ParagraphComponent,
    LanguageSwitchComponent,
    TitleComponent,
    NavigationComponent,
    QuoteComponent,
    LargeLoginComponent,
    NwpAdminInviteComponent,
    NwpUserListComponent,
    NwpListComponent,
    DeviceListComponent,
    DeviceDetailComponent,
    OrderHistoryComponent,
    OrderHistoryDetailComponent,
    OrderHistoryQuoteComponent,
    SignUpComponent,
    CmsComponentDirective,
    CmsSlotDirective,
    HeroBannerComponent,
    ProductSliderComponent,
    NextStepComponent,
    ErrorComponent,
    PhoneComponent,
    CustomerSupportComponent,
    ProductDetailComponent,
    AuthenticationComponent,
    BasketComponent,
    CheckoutStepsComponent,
    LoginCheckoutComponent,
    CheckoutAllInOnePageTemplateComponent,
    CheckoutAddressComponent,
    CheckoutDeliveryComponent,
    CheckoutPaymentComponent,
    CheckoutSummaryComponent,
    SignUpCompleteComponent,
    TwoColumPageTemplateComponent,
    AccordionComponent,
    SimpleTitleComponent,
    ContactBoxComponent,
    ContactFormComponent,
    ContactConfirmationComponent,
    SearchResultListComponent,
    CategoryListComponent,
    CategoryListItemComponent,
    ContactComponent,
    TitledParagraphComponent,
    PaymentIconsComponent,
    SearchResultTitleComponent,
    SearchNoResultComponent,
    NotAvailableComponent,
    TeaserComponent,
    ListItemComponent,
    SeoAccordionComponent,
    SeoContentComponent,
    PromotionBannerComponent,
  ],
  exports: [
    BaseSiteComponent,
    LogoComponent,
    AuthenticationComponent,
    NavigationComponent
  ],
  providers: [
    {provide: BaseLinkResolverService, useClass: LinkResolverService},
    {
      provide: HTTP_INTERCEPTORS,
      useClass: KionInterceptor,
      multi: true

    }
  ]
})
export class CmsModule {
  static forRoot(cmsConfig: Partial<CmsConfig> = {}, idpConfig: Partial<IdpConfig> = {}): ModuleWithProviders<CmsModule> {
    return {
      ngModule: CmsModule,
      providers: [
        {provide: CmsConfig, useValue: cmsConfig},
        {provide: IdpConfig, useValue: idpConfig}
      ]
    };
  }
}
